export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["min"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kaufen"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["für"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aktiv"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Anzeige-Link"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Maker-ID"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Beschreibung"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Timeout"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Erstellungsdatum"])},
  "11": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ich zahle"])},
  "12": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ich erhalte"])},
  "13": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Handelslimit"])},
  "14": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Alle"])},
  "15": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Trades"])},
  "16": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Angebots-ID"])},
  "17": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurs"])},
  "18": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Konto auswählen"])},
  "19": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Außerhalb des Limits"])}
}